import React from "react";

import SearchMapSection from "../companies/SearchMapSection";
import HomeLatestMembers from "../layout/HomeLatestMembers";
import HomeHriBenefits from "../layout/HomeHriBenefits";

export default function CompaniesMapPage() {
    return (
        <>
            <SearchMapSection defaultType="all" />
            <HomeLatestMembers />
            <HomeHriBenefits />
        </>
    );
}
